const state = {
  errorBag: []
};

const mutations = {
  SET_ERRORS(state, data) {
    state.errorBag = data;
  }
};

const getters = {
  getErrors: state => {
    return state.errorBag;
  }
};

const actions = {
  setErrors: ({commit}, payload) => {
    commit('SET_ERRORS', payload);
  },
};

export default {
  state,
  mutations,
  getters,
  actions
};



// WEBPACK FOOTER //
// ./src/store/modules/validate.js